module.exports = __webpack_public_path__ + "static/media/checkin-card-reader-a.747542a8.png";